
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { GroupLeaderResponse } from "@/types/admin";
import type { Database } from "@/integrations/supabase/types";

type SupportedLanguage = Database["public"]["Enums"]["supported_language"];

// RTL languages
const RTL_LANGUAGES = ["ar", "fa", "prs"];

interface SurveyRatingQuestionProps {
  question: string;
  field: keyof GroupLeaderResponse;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  language?: SupportedLanguage;
}

export const SurveyRatingQuestion = ({
  question,
  field,
  value,
  onChange,
  required = true,
  language = "sv",
}: SurveyRatingQuestionProps) => {
  const isRtl = RTL_LANGUAGES.includes(language);
  
  const options = [
    "Stämmer inte alls",
    "Stämmer dåligt",
    "Varken eller",
    "Stämmer delvis",
    "Stämmer helt"
  ];

  return (
    <div className="space-y-2 w-full" dir={isRtl ? "rtl" : "ltr"}>
      <Label 
        className={`block w-full ${isRtl ? 'text-right' : 'text-left'}`} 
        dir={isRtl ? "rtl" : "ltr"}
      >
        {question}
      </Label>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        required={required}
        className={`w-full ${isRtl ? 'items-end' : 'items-start'}`}
        dir={isRtl ? "rtl" : "ltr"}
      >
        {options.map((option, index) => (
          <div 
            key={`${field}_${index}`} 
            className={`flex items-center w-full ${isRtl ? 'flex-row-reverse justify-between' : 'justify-start space-x-2'}`}
          >
            {isRtl ? (
              <>
                <Label 
                  htmlFor={`${field}_${index}`}
                  dir="ltr"
                  className="text-left"
                >
                  {option}
                </Label>
                <RadioGroupItem 
                  value={option} 
                  id={`${field}_${index}`} 
                  data-index={index} 
                />
              </>
            ) : (
              <>
                <RadioGroupItem 
                  value={option} 
                  id={`${field}_${index}`} 
                  data-index={index} 
                />
                <Label 
                  htmlFor={`${field}_${index}`}
                  dir="ltr"
                  className="text-left"
                >
                  {option}
                </Label>
              </>
            )}
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};
